(function () {
  'use strict';

  // Lição da Ponte: JS não roda dentro de custom_liquid — por isso este arquivo
  // vive em assets/ e é carregado via <script src defer> normal, a partir de
  // snippets/bundle-buy-buttons.liquid.
  //
  // Objetivo: ler os 4 radios de snippets/bundle-variant-picker.liquid (Cor 1,
  // Tamanho 1, Cor 2, Tamanho 2), resolver cada par para um variant.id real do
  // produto (usando o JSON embutido em #BundleVariantsJSON-<section_id>), e
  // alimentar o mecanismo NATIVO de multi-variante que já existe em
  // assets/product-form.js (arquivo do tema, não editado):
  //   - input hidden name="id" com valor "variantId1,variantId2" (a vírgula
  //     aciona o `includes(',')` dentro de product-form.js, que descarta o
  //     campo "id" único do FormData antes do fetch)
  //   - .product-form__multiple-variant-ids preenchido com
  //     items[0][id]/items[0][quantity] e items[1][id]/items[1][quantity],
  //     que o fetch pro /cart/add.js já sabe interpretar — mesmo mecanismo
  //     usado por sections/bundle-deals.liquid (não alterada).
  //
  // Este arquivo NÃO mexe em carrinho/checkout além de preencher esses campos.
  // O fetch em si continua 100% dentro de product-form.js (não tocado), e a
  // interceptação da Ponte no checkout (ponte-redirect.js, não tocado) continua
  // rodando depois, sobre o carrinho já populado.
  //
  // O input name="id" nasce com o atributo disabled (igual ao snippet nativo
  // buy-buttons.liquid) — isso é seguro e não precisa de removeAttribute aqui:
  // product-form.js (linha 7 do construtor de <product-form>) já limpa esse
  // disabled sozinho, sempre, antes de qualquer submit ser possível.
  //
  // Galeria de imagens: o seletor nativo troca a foto chamando
  // gallery.setActiveMedia(mediaId, true) no <media-gallery id="MediaGallery-X">
  // (método público definido em assets/media-gallery.js, não editado). A gente
  // replica só essa chamada — sem envolver <variant-radios>/global.js, que
  // disparariam fetch de preço/SKU e updateURL que não servem pro bundle.
  // A galeria passa a seguir a ÚLTIMA peça (1 ou 2) cuja Cor/Tamanho mudou.

  var ADD_TO_CART_LABEL = 'Add to cart';
  var SOLD_OUT_LABEL = 'Sold out';

  function resolvePieceVariant(picker, variants, piece) {
    var fieldset = picker.querySelector('[data-bundle-piece="' + piece + '"]');
    if (!fieldset) return null;

    // Cada radio tem name="...-o<posição>"; extraímos a posição do próprio
    // name em vez de confiar na ordem do DOM — mais explícito e à prova de
    // reordenação futura do markup.
    var optionValues = {};
    fieldset.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
      var match = radio.name.match(/-o(\d+)$/);
      if (match) optionValues[match[1]] = radio.value;
    });

    // Posição 1 = Cor, posição 2 = Tamanho (garantido pela estrutura do produto).
    if (!optionValues['1'] || !optionValues['2']) return null;

    return (
      variants.filter(function (variant) {
        return variant.option1 === optionValues['1'] && variant.option2 === optionValues['2'];
      })[0] || null
    );
  }

  function initBundleProductForm() {
    var picker = document.querySelector('[data-bundle-variant-picker]');
    var idInput = document.querySelector('[data-bundle-id-input]');
    var multipleIdsContainer = document.querySelector('[data-bundle-multiple-variant-ids]');
    var submitButton = document.querySelector('[data-bundle-submit-button]');

    // Se algum gancho não existir, não é a página do bundle (ou algo não
    // carregou) — não faz nada, não quebra o resto da página.
    if (!picker || !idInput || !multipleIdsContainer || !submitButton) return;

    var variantsScript = document.querySelector('script[type="application/json"][id^="BundleVariantsJSON-"]');
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }

    var sectionId = variantsScript.id.replace('BundleVariantsJSON-', '');
    var submitButtonLabel = submitButton.querySelector('span');

    function updateBundle() {
      var variant1 = resolvePieceVariant(picker, variants, 1);
      var variant2 = resolvePieceVariant(picker, variants, 2);
      var bothResolved = Boolean(variant1 && variant2);
      var bothAvailable = bothResolved && variant1.available && variant2.available;

      if (bothResolved) {
        idInput.value = variant1.id + ',' + variant2.id;
        multipleIdsContainer.innerHTML =
          '<input type="hidden" name="items[0][id]" value="' + variant1.id + '">' +
          '<input type="hidden" name="items[0][quantity]" value="1">' +
          '<input type="hidden" name="items[1][id]" value="' + variant2.id + '">' +
          '<input type="hidden" name="items[1][quantity]" value="1">';
      } else {
        idInput.value = '';
        multipleIdsContainer.innerHTML = '';
      }

      submitButton.disabled = !bothAvailable;
      if (submitButtonLabel) {
        submitButtonLabel.textContent = bothAvailable ? ADD_TO_CART_LABEL : SOLD_OUT_LABEL;
      }
    }

    function updateGalleryForVariant(variant) {
      if (!variant || !variant.featured_media) return;
      var mediaId = sectionId + '-' + variant.featured_media.id;
      document.querySelectorAll('[id^="MediaGallery-' + sectionId + '"]').forEach(function (gallery) {
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(mediaId, true);
        }
      });
    }

    picker.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('input[type="radio"]')) {
        updateBundle();

        var fieldset = event.target.closest('[data-bundle-piece]');
        var piece = fieldset ? fieldset.getAttribute('data-bundle-piece') : null;
        if (piece) {
          updateGalleryForVariant(resolvePieceVariant(picker, variants, piece));
        }
      }
    });

    // Roda uma vez já na carga, pra refletir a pré-seleção default
    // (primeira cor + primeiro tamanho) nos 2 campos ocultos do form.
    updateBundle();
    updateGalleryForVariant(resolvePieceVariant(picker, variants, 1));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleProductForm);
  } else {
    initBundleProductForm();
  }
})();
